import React, { useEffect, useState } from 'react'
import { Row, Col, Card, Spin, Empty, message, Table } from 'antd'
import { useSelector } from 'react-redux'
import { getBadgesByStudent } from '../../../../../Constants/Api/functions/function'
import { SUPER_ADMIN, ADMIN, STUDENT } from '../../../../../Constants/Roles/roles'

const UserBadges = ({ user }) => {
    const [badges, setBadges] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const userProfile = useSelector(state => state.userProfile.userProfile)

    useEffect(() => {
        if (user?.id) {
            const fetchUserBadges = async () => {
                setIsLoading(true)
                try {
                    const data = await getBadgesByStudent(user.id)
                    if (Array.isArray(data)) {
                        setBadges(data)
                    } else {
                        setBadges([])
                    }
                } catch (error) {
                    console.error('Error fetching badges:', error)
                    message.error('Failed to fetch badges')
                    setBadges([])
                } finally {
                    setIsLoading(false)
                }
            }
            fetchUserBadges()
        }
    }, [user?.id])

    const isAdminOrSuperAdmin = userProfile?.role === SUPER_ADMIN || userProfile?.role === ADMIN

    const columns = [
        {
            title: 'Badge Image',
            dataIndex: 'BadgeImageURL',
            key: 'BadgeImageURL',
            render: (imageUrl) => imageUrl ? <img src={imageUrl} alt="Badge" style={{ width: '50px', height: '50px', objectFit: 'cover' }} /> : 'No Image'
        },
        {
            title: 'Badge Name',
            dataIndex: 'BadgeName',
            key: 'BadgeName'
        },
        {
            title: 'Description',
            dataIndex: 'BadgeDescription',
            key: 'BadgeDescription'
        },
        {
            title: 'Course',
            dataIndex: 'courseName',
            key: 'CourseName',
            render: (courseName) => courseName || 'N/A'
        },
        {
            title: 'Awarded Date',
            dataIndex: 'AwardDate',
            key: 'AwardDate',
            render: (awardDate) => awardDate || 'N/A'
        }
    ]

    return (
        <div style={{ padding: '20px' }}>
            <Spin spinning={isLoading} tip='Loading badges...'>
                {badges && badges.length > 0 ? (
                    isAdminOrSuperAdmin ? (
                        <Table
                            dataSource={badges}
                            columns={columns}
                            rowKey={(badge) => badge.StudentBadgeID || badge.BadgeID}
                            pagination={false}
                        />
                    ) : (
                        <Row gutter={[16, 16]}>
                            {badges.map((badge) => (
                                <Col xs={24} sm={12} md={8} lg={6} key={badge.StudentBadgeID || badge.BadgeID}>
                                    <Card
                                        hoverable
                                        cover={
                                            badge.BadgeImageURL ? (
                                                <img
                                                    alt={badge.BadgeName}
                                                    src={badge.BadgeImageURL}
                                                    style={{ height: '150px', objectFit: 'cover' }}
                                                />
                                            ) : (
                                                <div style={{ height: '150px', background: '#f0f0f0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                    <span style={{ color: '#999' }}>No Image</span>
                                                </div>
                                            )
                                        }
                                    >
                                        <Card.Meta
                                            title={badge.BadgeName}
                                            description={badge.BadgeDescription}
                                        />
                                        <div style={{ marginTop: '10px', fontSize: '12px', color: '#666' }}>
                                            <p><strong>Course:</strong> {badge.CourseName || 'N/A'}</p>
                                            <p><strong>Awarded:</strong> {badge.AwardDate || 'N/A'}</p>
                                        </div>
                                    </Card>
                                </Col>
                            ))}
                        </Row>
                    )
                ) : (
                    <Empty
                        description='No badges found'
                        style={{ marginTop: '50px' }}
                    />
                )}
            </Spin>
        </div>
    )
}

export default UserBadges
